import { SideNav } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { useAccountRequestContext } from '@frontend/utils/hooks/useAccountRequestContext';
import { OrganizationProfile } from '../../organizations/OrganizationProfile';

export function getAccountRequestPageNavigation() {
    return {
        sideBarNavigation: <Navigation />,
        sideBarProfile: <Profile size="large" />,
        topBarNavigation: <Navigation />,
        topBarProfile: <Profile size="small" />,
    };
}

function Navigation() {
    const { accountRequest } = useAccountRequestContext();
    const language = getSelectedLanguage();

    return (
        <SideNav>
            <SideNav.Link
                key="linkToOrganizationPage"
                label={language.organization.organization}
                to={`/organizations/${accountRequest.organizationId}/view`}
                variant="link"
            />
        </SideNav>
    );
}

function Profile(props: Readonly<{ size: 'large' | 'small' }>) {
    const { accountRequest } = useAccountRequestContext();

    return (
        <OrganizationProfile
            hideTxcsId={true}
            linkToOrganizationPage={true}
            organizationId={accountRequest.organizationId}
            size={props.size}
        />
    );
}
